import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useParams } from 'react-router-dom';
import { Loading } from '../../common/Loading/Loading';
import RequestPage from './RequestPage';
import RequestListPage from './RequestListPage';
import ExtDataPage from './ExtDataPage';
import { requestsActions } from '../../../actions';
import { RequestRoomPage } from './RequestRoomPage';

function RequestsPage() {
    const { eventName } = useParams();
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => ({
        isLoading: !state.requests.requests,
    }));
    useEffect(() => {
        //console.log('useEffect ' + eventName);
        dispatch(requestsActions.updateCurrentEventAndUpdateRequests(eventName));
    }, [eventName, dispatch]);
    return (
        <>
            {isLoading ? (
                <div className="position-relative mt-5">
                    <Loading text="Ожидание данных..." />
                </div>
            ) : (
                <Routes>
                    <Route path={`extData/:requestNum`} element={<ExtDataPage />} />
                    <Route path={`:requestNum`} element={<RequestPage />} />
                    <Route path={':requestNum/room'} element={<RequestRoomPage />} />
                    <Route path="" element={<RequestListPage />} />
                </Routes>
            )}
        </>
    );
}

export default RequestsPage;
